/** @format */

const formatNames = name => {
  let formattedName = name
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
  return formattedName;
};

export default formatNames;
